import { t } from "@/utils/method";
import type { FormInstance, RuleObject } from "antd/lib/form";
//安全密码强度
/* eslint-disable */
let minSafePwdLevel = 3;

//检测密码强度（内部使用）
export function ret(value?: any) {
  return Promise.reject(value);
}
export function res(value?: any) {
  return Promise.resolve(value);
}
export function checkPwdStrengths(pwd: string) {
  let level = 0;
  if (pwd.length >= 8) level++;
  //正则表达式验证符合要求的
  if (/\d/.test(pwd)) level++; //数字
  // if (/[a-z]/.test(pwd)) level++; //小写
  if (/[A-Z]/.test(pwd)) level++; //大写
  // if (/\W/.test(pwd)) level++; //特殊字符
  // if (level > 1 && pwd.length > 12) level++; //超过12位并且两种组合以上
  return level;
}

export function checkSafePwdStrengths(pwd: string) {
  let level = 0;
  if (pwd.length >= 6) level++;
  //正则表达式验证符合要求的
  // eslint-disable-next-line
  if (/^(?![\d]+$)(?![a-zA-Z]+$)(?![!@#\$%\^&\*\(\)]+$)[\da-zA-Z!@#\$%\^&\*\(\)]{2,20}$/.test(pwd)) level++;
  if (pwd.length <= 20) level++;
  return level;
}

//展示当前的用户验证码种类
export function showLoginAuthWord(key?: number) {
  /* eslint-disable */
  let array = [t("account.loginPwd"), t("account.GoogleAuthenticationCode"), t("account.VerificationRemoteLogin")],
    word = t("account.CurrentSettings") + ": ";
  switch (key) {
    case 2:
      return word + array[0] + "+" + array[1];
    case 3:
      return word + array[0] + "+" + array[2];
    case 4:
      return word + array[0] + "+" + array[1] + "+" + array[2];
    default:
      return word + array[0];
  }
}

// 手机号验证
export function MobileNumberValidator(rule: RuleObject, value: any) {
  const idcardReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
  if (!value) {
    return ret(t("account.pleaseEnterPhone"));
  }
  if (!idcardReg.test(value)) {
    return ret(t("account.mobileNumber"));
  }
  return res();
}

// 邮箱验证
export function EmailValidator(rule: RuleObject, value: any) {
  // eslint-disable-next-line
  const idcardReg = /^([a-zA-Z0-9_\.-])+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/;
  if (!value) return ret(t("account.emailAddress"));
  if (!idcardReg.test(value)) return ret(t("account.emailAddress"));
  return res();
}

// 身份证验证
export function IDValidator(rule: RuleObject, value: any) {
  // eslint-disable-next-line
  const idcardReg =
    /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/;
  if (!idcardReg.test(value)) return ret(t("account.pleaseEnterRightId"));
  return res();
}

//检测安全密码规则
export function checkSafely(rule: RuleObject, value: any) {
  if (!value) {
    return res(true);
  }
  if (checkPwdStrengths(value) < minSafePwdLevel) {
    return ret(t("account.differentKindsOfCharacters"));
  }
  return res();
}

//  整数数字
export function isAllNumber(rule: RuleObject, value: any) {
  // var regExp = new RegExp("/^[0-9]{5,11}$/");
  if (!/^[0-9]{5,11}$/.test(value)) {
    return ret(t("account.plsInputPhone"));
  }
  return res();
}

// 老的密码
export function oldPassword(rule: RuleObject, value: any) {
  if (value.length < 6) {
    return ret(t("account.passwordCannotBeLess"));
  }
  return res();
}

//新的密码
export function newPassword(rule: RuleObject, value: any) {
  if (checkPwdStrengths(value) < minSafePwdLevel) {
    return ret(" ");
  }
  return res();
}

//新的密码2 rules数组 直接使用函数不使用对象， 会得到getFieldValue用于获取表单其他值进行高级验证
export function newPassword2({ getFieldValue }: FormInstance) {
  return {
    validator(rule: RuleObject, value: any) {
      if (checkPwdStrengths(value) < minSafePwdLevel) {
        return ret(" ");
      }
      if (getFieldValue("newPassword") !== value) {
        return ret(t("2fa.pwdNoMatch"));
      }
      return res();
    },
  };
}

//新的安全密码
export function newSafePassword(rule: RuleObject, value: any) {
  if (checkSafePwdStrengths(value) < minSafePwdLevel) {
    return ret(" ");
  }
  return res();
}

//新的安全密码2
export function newSafePassword2({ getFieldValue }: FormInstance) {
  return {
    validator(rule: RuleObject, value: any) {
      if (checkSafePwdStrengths(value) < minSafePwdLevel) {
        return ret(" ");
      }
      if (getFieldValue("newSafePassword") !== value) {
        return ret(t("2fa.spwdNoMatch"));
      }
      return res();
    },
  };
}

//js简单数组转对象
export function arrToObj(arr: (string | number)[], source?: (string | number)[]) {
  /* eslint-disable */
  let obj = {};
  if (!source && !source!.length) {
    /* eslint-disable */
    for (let i of arr) {
      obj[i] = 1;
    }
  } else {
    /* eslint-disable */
    for (let i of source!) {
      if (arr.includes(i)) {
        obj[i] = 1;
      } else {
        obj[i] = 0;
      }
    }
  }
  return obj;
}
